import { Settings as SettingsIcon } from 'lucide-react'

export default function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Settings</h1>
        <p className="text-gray-400">Platform configuration and preferences</p>
      </div>

      <div className="card p-12 text-center">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-gray-700 mb-4">
          <SettingsIcon className="h-8 w-8 text-gray-400" />
        </div>
        <h2 className="text-xl font-semibold text-white mb-2">Coming Soon</h2>
        <p className="text-gray-400 max-w-md mx-auto">
          Platform settings and configuration options are currently managed through
          Cloudflare Dashboard and GitHub deployment settings.
        </p>
      </div>
    </div>
  )
}
